import { render } from "./ClubCard-JoinClub.vue?vue&type=template&id=a4541a6c&scoped=true"
import script from "./ClubCard-JoinClub.vue?vue&type=script&lang=js"
export * from "./ClubCard-JoinClub.vue?vue&type=script&lang=js"

import "./ClubCard-JoinClub.vue?vue&type=style&index=0&id=a4541a6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4541a6c"]])

export default __exports__